// extracted by mini-css-extract-plugin
export var cardWrapper = "_49-0";